export const assetsTabs = {
	BLOCK_LIBRARY: 'BLOCK_LIBRARY',
	SKETCH: 'SKETCH',
	ARTWORK: 'ARTWORK'
};

export const docType = {
	ASSETS_IMAGE_S1: 'ASSETS_IMAGE_S1',
	ASSETS_IMAGE_S2: 'ASSETS_IMAGE_S2',
	ASSETS_IMAGE_S3: 'ASSETS_IMAGE_S3',
	ASSETS_IMAGE_S4: 'ASSETS_IMAGE_S4'
};

export const tagColors = [
	'#EDE3FE',
	'#FBD9C2',
	'#FFEAEA',
	'#DBFFE5',
	'#FEEAC1',
	'#D0F0FD',
	'#F4DBE6',
	'#EDDBD5',
	'#FFD66E',
	'#C2F5E9'
];
